import { useAppSelector } from '@hooks/statehooks';
import { PricingBreakdownItem } from 'interface';
import {
  excessMileageTooltip,
  initialPaymentTooltip,
  numberOfPaymentTooltip,
  processingFeeTooltip,
  totalCostOfLeaseTooltip,
  totalCostOfLeaseTooltipHyperLink,
} from '../resources';

export const usePricingBreakdown = (): PricingBreakdownItem[] => {
  const { pricing } = useAppSelector((state) => state.vehiclePrice);
  const { initial_payment: initialPayment } = useAppSelector(
    (state) => state.vehicleSearchParams
  );

  const items: PricingBreakdownItem[] = [
    {
      label: 'Total cost of lease',
      tooltip: totalCostOfLeaseTooltip,
      tooltipHyperlink: totalCostOfLeaseTooltipHyperLink,
      value: `£${pricing?.total?.toLocaleString('en-GB')}`,
      displayAsTooltip: false,
    },
    {
      label: 'Initial payment',
      tooltip: initialPaymentTooltip,
      value: `£${initialPayment.toLocaleString('en-GB')}`,
      displayAsTooltip: true,
    },
    {
      label: 'Number of payments',
      tooltip: numberOfPaymentTooltip,
      value: `${pricing?.payments}`,
      displayAsTooltip: true,
    },
    {
      label: 'Processing fee',
      tooltip: processingFeeTooltip,
      value: `£${pricing?.processingFee}`,
      displayAsTooltip: true,
    },
    {
      label: 'Excess mileage charge per mile',
      tooltip: excessMileageTooltip,
      value: `${pricing?.excessMileCharge}p`,
      displayAsTooltip: true,
    },
  ];

  return items;
};
